module.exports = __webpack_public_path__ + "static/brand_yum_banner-1ca32631da92be63e204b1fce78bc15a.jpg";